export default function checkAuthTokenValidity(error) {
    if (error.response && error.response.status === 401) {
        // Redirect to sign-in page on 401 Unauthorized error
        console.log("enter in 401", error.response.status)
        window.location = `${process.env.VUE_APP_URL}sign-in`;
    } else {
        // Handle other errors
        console.error('Authentication token error:', error);
    }
}